import { Link, useLocation } from 'react-router-dom';
import { Stack, Text } from '@repletoryreach/sdk-ui';
import { Alert } from '@repletoryreach/sdk-ui/data-display';
import { MfaForm } from './components/MfaForm';
import { AuthCardHeader } from '../components/AuthCardHeader';
import { ArrowLeftIcon, ShieldIcon } from '../components/icons';
import { useT } from '../../../i18n/I18nProvider';

/**
 * The second step of sign-in.
 *
 * This route used to render one alert saying MFA was "pending W24 (Phase 8
 * hardening)" while the same app was already prompting for a TOTP code inside
 * the login form and the platform enforced it. Nothing navigated here either.
 * It is the real challenge screen now, and the login form sends the operator
 * to it when identity answers with a pending token.
 */
export default function MfaPage() {
  const t = useT();
  const location = useLocation();
  const state = location.state as { challenge?: boolean; from?: string } | null;

  if (!state?.challenge) {
    return (
      <Stack gap="md">
        <AuthCardHeader
          title={t('auth.mfa.title')}
          subtitle={t('auth.staffOnly')}
          icon={<ShieldIcon size={48} />}
        />
        <Alert color="warning">
          <Text fz="sm">{t('auth.mfa.noChallenge')}</Text>
        </Alert>
        <Link to="/auth/login" className="admin-auth__row-link" replace>
          <ArrowLeftIcon />
          {t('auth.login.twoFactor.back')}
        </Link>
      </Stack>
    );
  }

  return (
    <Stack gap="md">
      <AuthCardHeader
        title={t('auth.mfa.title')}
        subtitle={t('auth.staffOnly')}
        icon={<ShieldIcon size={48} />}
      />
      <MfaForm redirectTo={state.from ?? '/'} />
    </Stack>
  );
}
